import React, { useState } from 'react';
import { Card, CardContent, Container, Slide } from '@mui/material';
import { MonthlyValues, PriceFooterDetails } from './PriceFooterDetails';
import useVisibilityOnScroll from '../../hooks/useVisibilityOnScroll';
import { RenewalRatingResponse } from '../../services/renewalsApi';
import { IPaymentOptionValue } from '../renewal/paymentOptionsSelector';
export type PriceFooterProps = {
	paymentOptions: RenewalRatingResponse;
	value?: IPaymentOptionValue;
	monthlyValues: MonthlyValues;
};

const PriceFooter: React.FC<PriceFooterProps> = ({ paymentOptions, value, monthlyValues }) => {
	const [expanded, setExpanded] = useState(false);
	const isVisible = useVisibilityOnScroll();

	return (
		<Slide direction='up' in={isVisible || expanded} mountOnEnter unmountOnExit>
			<Card
				variant='outlined'
				sx={(theme) => ({
					position: 'fixed',
					bottom: 0,
					left: 0,
					right: 0,
					width: '100%',
					zIndex: 999,
					boxShadow: '0px -2px 10px rgba(0, 0, 0, 0.2)',
					backgroundColor: theme.palette.secondary.main,
					backgroundImage: 'linear-gradient(180deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.5))',
					color: 'white',
				})}
			>
				<Container>
					<CardContent onClick={() => value && setExpanded(!expanded)} sx={{ paddingBottom: '12px !important' }}>
						<PriceFooterDetails
							expanded={expanded}
							setExpanded={setExpanded}
							paymentOptions={paymentOptions}
							value={value}
							monthlyValues={monthlyValues}
						/>
					</CardContent>
				</Container>
			</Card>
		</Slide>
	);
};

export default PriceFooter;
